<div class="container-scroller">
  <app-header></app-header>
  <div class="container-fluid page-body-wrapper">
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="row mt-4 mb-4">
          <div class="card card-body">
            <div class="row">
              <div class="col-lg-4 d-flex grid-margin stretch-card">
                <div class="card sale-diffrence-border">
                  <div class="card-body">
                    <a (click)="router.navigate(['administrator/userMaster'])">
                      <h2 class="text-dark mb-2 font-weight-bold">
                        User Master
                      </h2>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 d-flex grid-margin stretch-card">
                <div class="card sale-diffrence-border">
                  <div class="card-body">
                    <a (click)="router.navigate(['administrator/userRights'])"
                      ><h2 class="text-dark mb-2 font-weight-bold">
                        User Rights
                      </h2></a
                    >
                    <!-- <h4 class="card-title mb-2">Sales Difference</h4>
                    <small class="text-muted">APRIL 2019</small> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-4 d-flex grid-margin stretch-card">
                <div class="card sale-diffrence-border">
                  <div class="card-body">
                    <h2 class="text-dark mb-2 font-weight-bold">
                      Update Transaction
                    </h2>
                    <!-- <h4 class="card-title mb-2">Sales Difference</h4>
                    <small class="text-muted">APRIL 2019</small> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-4 d-flex grid-margin stretch-card">
                <div class="card sale-diffrence-border">
                  <div class="card-body">
                    <h2 class="text-dark mb-2 font-weight-bold">Log Details</h2>
                    <!-- <h4 class="card-title mb-2">Sales Difference</h4>
                    <small class="text-muted">APRIL 2019</small> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-4 d-flex grid-margin stretch-card">
                <div class="card sale-diffrence-border">
                  <div class="card-body">
                    <h2 class="text-dark mb-2 font-weight-bold">
                      Company Information
                    </h2>
                    <!-- <h4 class="card-title mb-2">Sales Difference</h4>
                    <small class="text-muted">APRIL 2019</small> -->
                  </div>
                </div>
              </div>
              <div class="col-lg-4 d-flex grid-margin stretch-card">
                <div class="card sale-diffrence-border">
                  <div class="card-body">
                    <h2 class="text-dark mb-2 font-weight-bold">
                      Database Backup
                    </h2>
                    <!-- <h4 class="card-title mb-2">Sales Difference</h4>
                    <small class="text-muted">APRIL 2019</small> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="container align-item-center" *ngIf="!menuAccess">
            <h1 class="text-center" style="padding: 80px 20px;">
              OOPS!!! You don't have access to this Page...
            </h1>
            <p class="text-center">Please Contact Administrator</p>
          </div>
        </div> -->
          <app-footer></app-footer>
        </div>
      </div>
    </div>
  </div>
</div>
